import { FC } from 'react';
import { Consumer as StateConsumer } from '../context/state';
import _Footer from '../component/compound/Footer';

const Footer: FC = () => (
  <StateConsumer>
    {(state) =>
      // !state.authentication.signedInUser ||
      state.fatalError ? null : <_Footer />
    }
  </StateConsumer>
);

export default Footer;
